import React, { ReactNode } from "react";
import Box from "@mui/material/Box";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "dayjs/locale/nl";
import dayjs, { Dayjs } from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { TimeField, TimePickerProps } from "@mui/x-date-pickers-pro";

dayjs.extend(updateLocale);
dayjs.updateLocale("nl", { weekStart: 0 });
dayjs.locale("nl");

export type WcTimePickerProps = TimePickerProps & {
  controlDisabled?: boolean;
  children?: ReactNode;
  width?: number;
  required?: boolean;
  error?: any;
  format?: string;
  value?: Dayjs | string;
};

export const WcTimePicker = (props: WcTimePickerProps) => {
  const { controlDisabled, width, required, error, format, value, slotProps, label, sx, ...rest } = props;

  return (
    <Box width={width ? width : 165} id="WcTimePicker">
      <LocalizationProvider adapterLocale={"nl"} dateAdapter={AdapterDayjs}>
        <TimeField
          label={label}
          value={value}
          sx={[...(Array.isArray(sx) ? sx : [sx])]}
          disabled={controlDisabled}
          required={required}
          {...props.slots}
          {...props.slotProps}
          {...rest}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default WcTimePicker;
